import { createFileRoute } from "@tanstack/react-router";
import { GitComponent } from "@/pages/git";
import { head, loader } from "@/pages/git.meta";

export const Route = createFileRoute("/$locale/git")({
  loader,
  head,
  component: GitComponent,
});
